import { cn } from '@/lib/utils';
import { REGUAS } from '@/data/dashboardMockData';

interface ReguaSelectorProps {
  selectedReguaId: string;
  onSelect: (reguaId: string) => void;
}

export function ReguaSelector({ selectedReguaId, onSelect }: ReguaSelectorProps) {
  const options = [
    { id: 'all', nome: 'Todas' },
    ...REGUAS.map(r => ({ id: r.id, nome: r.nome.split('(')[0].trim() })),
  ];

  return (
    <div className="flex items-center gap-1 p-1 bg-muted rounded-lg flex-wrap">
      {options.map((option) => (
        <button
          key={option.id}
          onClick={() => onSelect(option.id)}
          className={cn(
            'px-3 py-1.5 text-xs font-semibold rounded-md transition-all duration-200',
            selectedReguaId === option.id
              ? 'bg-card text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
        >
          {option.nome}
        </button>
      ))}
    </div>
  );
}
